export default "__VITE_ASSET__8tx9ZkPT__"